<template>
  <div ref="highlightLayer" class="highlight-layer"></div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import * as d3 from 'd3';
import { cleanx,
  isLastDayOfMonth, 
  getBavariaHolidaysBetween, 
  dayMs,
  getWidthPerDay
} from "./planner.js";

// 1. ADD PROPS: This is crucial for reactivity
const props = defineProps({
  startDate: { type: Date, required: true },
  endDate: { type: Date, required: true },
  configs: { type: Array, required: true },
  isprintView: { type: Boolean, required: true}
});

const highlightLayer = ref(null);

function renderHighlight() {
  const widthPerDay = getWidthPerDay(props.isprintView)
  if (!highlightLayer.value || isNaN(props.startDate.getTime())) return;

  // 2. CLEAR PREVIOUS: Remove old highlights before drawing new ones
  highlightLayer.value.innerHTML = '';

  const days = d3.timeDay.range(props.startDate, props.endDate);
  const holidays = getBavariaHolidaysBetween(props.startDate, props.endDate);
  const totalDays = (props.endDate - props.startDate) / dayMs;
  const x = d3.scaleUtc()
    .domain([props.startDate, props.endDate])
    .range([0, totalDays * widthPerDay]);

  days.forEach(day => {
    const isWeekend = day.getDay() === 0 || day.getDay() === 6;
    const isHoliday = holidays.some(h => h.date.toDateString() === day.toDateString());
    const isLdm = isLastDayOfMonth(day);

    // Create the background highlight (Weekend/Holiday)
    if (isWeekend || isHoliday) {
      let div = document.createElement("div");
      div.className = `highlight day ${isWeekend ? 'weekend' : 'holiday'}`;
      div.style.left = `${cleanx(x, day)}px`;
      div.style.width = `${widthPerDay}px`;
      highlightLayer.value.appendChild(div);
    }

    // Create the vertical separators (Month/Week ends)
    if (isLdm || day.getDay() === 0) {
      let div = document.createElement("div");
      div.className = `highlight day ${isLdm ? 'last_day_month' : 'last_day_week'}`;
      let offset = isLdm ? 2 : 1;
      div.style.left = `${cleanx(x, day) + widthPerDay + offset}px`;
      highlightLayer.value.appendChild(div);
    }
  });
}

// 3. WATCH: Redraw if the parent changes the dates
watch(() => [props.startDate, props.endDate], renderHighlight);

onMounted(renderHighlight);
</script>

<style scoped>
.highlight-layer {
  pointer-events: none;
}
</style>
